var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404Moon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9715 100.138C77.57 100.138 99.943 77.7217 99.943 50.0692C99.943 22.4168 77.57 0 49.9715 0C22.373 0 0 22.4168 0 50.0692C0 77.7217 22.373 100.138 49.9715 100.138Z",
    fill: "#FFE33B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3884 0C59.3804 5.91421 66.2288 14.5767 69.9164 24.7009C73.604 34.8252 73.9341 45.8711 70.8577 56.1983C67.7813 66.5255 61.4625 75.583 52.8397 82.0257C44.2169 88.4684 33.7501 91.9526 22.9938 91.9608H22.5781C29.0739 96.2273 36.4729 98.9178 44.1877 99.8189C51.9025 100.72 59.7207 99.8069 67.0218 97.152C74.3228 94.497 80.9057 90.1734 86.248 84.5244C91.5902 78.8753 95.5446 72.0562 97.7974 64.6085C100.05 57.1608 100.539 49.2895 99.2257 41.6194C97.9122 33.9492 94.8324 26.6914 90.2307 20.4221C85.629 14.1528 79.6321 9.04453 72.716 5.50282C65.8 1.96111 58.1551 0.083482 50.3884 0.0189338V0Z",
    fill: "#FFC700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Moon);
export default __webpack_public_path__ + "static/media/404_moon.6791b638f6544ae80dc781d0d4285f25.svg";
export { ForwardRef as ReactComponent };